// extracted by mini-css-extract-plugin
module.exports = {"container":"richText_container__348p4","input":"richText_input__1w74F","error":"richText_error__3Jt01"};